import React, { Fragment, useCallback } from 'react';
import { Text, Box } from 'roo-ui/components';
import TextButton from 'components/TextButton';
import { useModal } from 'lib/hooks';
import Modal from 'components/Modal';
import { useDataLayer } from 'hooks/useDataLayer';

const PointsLearnMore = () => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();

  const handleOpenModal = useCallback(() => {
    openModal();
    emitInteractionEvent({
      type: 'Learn More Link',
      value: 'Pay In Full Selected',
    });
  }, [emitInteractionEvent, openModal]);

  return (
    <Fragment>
      <TextButton onClick={handleOpenModal} color="inherit">
        Important Information
      </TextButton>
      <Modal {...modalProps} title="Redeeming Qantas Points for hotels">
        <Text display="block" mb="5" fontSize={['sm', 'base']} data-testid="modal-learn-more-text">
          <Box>
            Logged in Qantas Frequent Flyer members can redeem Qantas Points when booking at qantas.com for all hotels. The ability to use
            Points Plus Pay is subject to meeting the minimum requirement of 5,000 Qantas Points and cannot be used for Classic Hotel
            Rewards.
          </Box>
          <Box mt={4}>
            Qantas Points deduction: Once a booking is confirmed, Qantas Frequent Flyer members will receive an email and the number of
            Qantas Points required for the hotel will be deducted from their Qantas Frequent Flyer account.
          </Box>
          <Box mt={4}>
            If a member is eligible for a refund, they can elect whether to receive that refund (less any applicable fee) in cash, Qantas
            Points, or a combination of cash and Qantas Points. However, the number of Qantas Points or the cash amount refunded in such
            circumstances cannot exceed the number of Qantas Points originally used or the cash amount originally paid in respect of the
            booking.
          </Box>
          <Box mt={4}>
            Qantas Points cannot be redeemed for additional charges due to the hotel for extras (including cots, breakfasts and other
            incidentals) on check-in or check-out (as applicable).
          </Box>
          <Box mt={4}>
            Earning Qantas Points when redeeming Qantas Points for hotels: Qantas Frequent Flyer members can earn Points on eligible hotels.
            When members redeem Qantas Points for hotels, Qantas Points will be earned on eligible hotels based on the dollar value
            advertised at the time of the booking if the Member had paid in cash. Qantas Points will not be earned on cancelled bookings and
            on Classic Hotel Rewards.
          </Box>
        </Text>
      </Modal>
    </Fragment>
  );
};

export default PointsLearnMore;
